import DispatchedTypography from './DispatchedTypography';

export default DispatchedTypography;
